export default "/images/f8aa80e5faf89b5600f8cf32dd1706db.avif";